export default __webpack_public_path__ + "static/media/shield-check.83822417.svg";